export const FLOW_GROUP_NAMES = [
  "Language and literature",
  "Language acquisition",
  "Individuals and societies",
  "Sciences",
  "Mathematics",
  "Arts or another subject",
];

export const FLOW_MARK_NAMES = {
  P1: "Paper 1", P2: "Paper 2", "P2(L)": "Listening", IO: "Individual oral",
  IA: "Internal assessment", "IA.": "Internal assessment", Essay: "HL essay",
  "HL Ext.": "HL extension", "Design Proj.": "Design project",
  "Phil. Analysis": "Philosophical analysis", "Exp. Study": "Experimental study",
  "Music in Context": "Music in context", "Exp. w/ Music": "Experimenting with music",
  "Music-Maker": "Collaborative music", "Comp. & Analysis": "Composition and analysis",
  "Dance Inv.": "Dance investigation", "Text. Analysis": "Textual analysis",
  "Comp. Study": "Comparative study", "Collab. Film": "Collaborative film",
  "Research Pres.": "Research presentation", "Collab. Project": "Collaborative project",
  "Prod. Proposal": "Production proposal", "Written Assign.": "Written assignment",
  "Trans. Perf. & IO": "Performance and oral",
};

export const FLOW_DEFAULT_CHOICES = {
  groupOne: { type: "Language and Literature", level: "HL", language: "English" },
  groupTwo: { track: "langB", level: "SL", subject: "SL Spanish B" },
  groupThree: { subject: "History", level: "HL", pathway: "Europe" },
  groupFour: { subject: "Biology", level: "SL" },
  groupFive: { subject: "Analysis And Approaches", level: "HL" },
  groupSix: { selectedGroup: "6", subject: "Music", level: "SL" },
};

export const flowGradeColour = (grade) => grade == null
  ? "#b9bec6"
  : `hsl(${Math.round(grade / 7 * 120)} 75% 34%)`;

export const flowMarkName = (key, name) => key === "writing" ? "Writing" : key === "reading" ? "Reading" : FLOW_MARK_NAMES[name] || name;
